export const DEFAULT_MESSAGE_ID = -1;